import { config } from "../../lib/shared/config";
import { out } from "../../lib/output/out";
import { VERSION } from "../../lib/version/version-constants";
import { HELP } from "@/commands/help/help-constants";

export function helpCommand(): void {
  // Resolved, not a placeholder: the reader can click straight through to the
  // Scalar reference for the platform this CLI is actually pointed at.
  const baseUrl = config.load().baseUrl.replace(/\/$/, "");
  out.line(`${HELP}hepha ${VERSION} · full reference: ${baseUrl}/api/v1/docs`);
}
